// extracted by mini-css-extract-plugin
export default {"root":"BuyerProfiles__root--b_t6v"};